import React from 'react';

interface CityMobileTabsProps {
  activeTab: 'list' | 'map';
  onTabChange: (tab: 'list' | 'map') => void;
}

const ListIcon = () => (
  <svg viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
    <path d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" />
  </svg>
);

const MapIcon = () => (
  <svg viewBox="0 0 576 512" width="14" height="14" fill="currentColor">
    <path d="M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm-120 8a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.6 512H428.4c20.3 0 36.5-16.7 35.9-37l-7.4-250.3C446.1 249.2 436 273 424 296h-8l6.7 216H153.3l6.7-216h-8c-12-23-22.1-46.8-32.9-71.3L111.7 475c-.6 20.3 15.6 37 35.9 37z" />
  </svg>
);

export function CityMobileTabs({ activeTab, onTabChange }: CityMobileTabsProps) {
  return (
    <div className="case-mobile-tabs">
      <button
        type="button"
        className={`case-mobile-tab-btn${activeTab === 'list' ? ' active' : ''}`}
        onClick={() => onTabChange('list')}
      >
        <ListIcon /> List View
      </button>
      <button
        type="button"
        className={`case-mobile-tab-btn${activeTab === 'map' ? ' active' : ''}`}
        onClick={() => onTabChange('map')}
      >
        <MapIcon /> Map View
      </button>
    </div>
  );
}

export default CityMobileTabs;
